import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../colorVars';

export const LastLine = ({ dataArray, scaleX, scaleY }) => {
  if (scaleY == null || scaleX === null || dataArray.length < 2) return null;
  return (
    <g stroke={colors.blue}>
      {dataArray.map((item, index) => {
        if (index === 0) return null;
        const previousPrice = scaleY(dataArray[index - 1].last);
        const currentPrice = scaleY(item.last);
        return <line key={'' + index + item} x1={scaleX(index - 1)} x2={scaleX(index)} y1={previousPrice} y2={currentPrice} />;
      })}
    </g>
  );
};

LastLine.propTypes = {
  dataArray: PropTypes.array,
  scaleX: PropTypes.func,
  scaleY: PropTypes.func
};
